var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditalt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8967 3.10308C20.4466 2.65315 19.8363 2.40039 19.1999 2.40039C18.5635 2.40039 17.9532 2.65315 17.5031 3.10308L8.3999 12.2063V15.5999H11.7935L20.8967 6.49668C21.3466 6.04661 21.5994 5.43627 21.5994 4.79988C21.5994 4.16348 21.3466 3.55314 20.8967 3.10308Z",
    fill: "#272343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 7.20078C2.3999 6.56426 2.65276 5.95381 3.10285 5.50372C3.55293 5.05364 4.16338 4.80078 4.7999 4.80078H9.5999C9.91816 4.80078 10.2234 4.92721 10.4484 5.15225C10.6735 5.3773 10.7999 5.68252 10.7999 6.00078C10.7999 6.31904 10.6735 6.62427 10.4484 6.84931C10.2234 7.07435 9.91816 7.20078 9.5999 7.20078H4.7999V19.2008H16.7999V14.4008C16.7999 14.0825 16.9263 13.7773 17.1514 13.5523C17.3764 13.3272 17.6816 13.2008 17.9999 13.2008C18.3182 13.2008 18.6234 13.3272 18.8484 13.5523C19.0735 13.7773 19.1999 14.0825 19.1999 14.4008V19.2008C19.1999 19.8373 18.947 20.4477 18.497 20.8978C18.0469 21.3479 17.4364 21.6008 16.7999 21.6008H4.7999C4.16338 21.6008 3.55293 21.3479 3.10285 20.8978C2.65276 20.4477 2.3999 19.8373 2.3999 19.2008V7.20078Z",
    fill: "#272343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditalt);
export default __webpack_public_path__ + "static/media/editalt.60a6ac7d12a49d5637fe7f8215147628.svg";
export { ForwardRef as ReactComponent };